import React from 'react'
import Box from '@components/Box'
import styled from 'styled-components'
import InputSlider from '@components/InputSlider'
import { IControl, TRate } from '../types'
import { FormatType } from '@components/InputSlider'
import { Select, SelectOption } from '@components/Select'
import { LabeledValue } from 'ui-kit-sber/dist/js/components/Select/types'
import { CForm, CFormItem } from '@components/Utils/CForm'

const CONTRIBUTIONS_RATE = [
  { value: 'month', name: 'Ежемесячно' },
  { value: 'quarter', name: 'Ежеквартально' },
  { value: 'year', name: 'Ежегодно' },
]

const SSelect = styled(Select)`
  width: 100%;
`

const RATE_TEXT = {
  month: 'Ежемесячный',
  quarter: 'Ежеквартальный',
  year: 'Ежегодный',
}

const RATE_MIN = {
  month: 5000,
  quarter: 15000,
  year: 60000,
}

const Control: React.FC<IControl> = ({ values, onChange }) => {
  const { contribution, period, rate } = values

  const periodHandler = (period: number) => onChange({ ...values, period })
  const rateHandler = (rate: TRate) => onChange({ ...values, rate })
  const contributionHandler = (contribution: number) => onChange({ ...values, contribution })

  return (
    <>
      <CForm>
        <Box mb={{ xs: '20px', xl: '36px' }}>
          <CFormItem name="rate" label="Укажите периодичность взносов" defaultValue={rate}>
            <SSelect
              size="large"
              value={rate}
              onChange={(value: string | number | (string | number)[] | LabeledValue | LabeledValue[]) =>
                rateHandler(value as TRate)
              }
              placeholder="Частота взносов"
            >
              {CONTRIBUTIONS_RATE.map((rate) => (
                <SelectOption key={rate.value} value={rate.value}>
                  {rate.name}
                </SelectOption>
              ))}
            </SSelect>
          </CFormItem>
        </Box>
        <Box mb={{ xs: '40px', xl: '56px' }}>
          <CFormItem name="contribution" label="Укажите размер взносов" defaultValue={contribution}>
            <InputSlider
              min={RATE_MIN[rate]}
              step={1000}
              max={1000000}
              value={contribution}
              onChange={contributionHandler}
              formatType={FormatType.money}
              inputLabel={`${RATE_TEXT[rate]} взнос`}
            />
          </CFormItem>
        </Box>
        <Box mb="10px">
          <CFormItem name="period" label="Укажите сколько лет планируете копить" defaultValue={period}>
            <InputSlider
              min={5}
              step={1}
              max={25}
              value={period}
              onChange={periodHandler}
              formatType={FormatType.years}
              inputLabel="Период уплаты взносов"
            />
          </CFormItem>
        </Box>
      </CForm>
    </>
  )
}

export default Control
